import React from 'react';
import dotAccess from 'dot-access';
import { DeleteAssociationButton } from '../output/CrudButton';
import './DeletableRow.css';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';

export const DeletableRow = props => {
  const { showDeleteButton } = props;

  return (
    <div className="DeletableRow">
	    <div className="output-container">{props.value}</div>
	    <div className="button-container">
	      {showDeleteButton ?
        <DeleteAssociationButton {...props} /> : ''
        }
	    </div>
	  </div>
  );
};

const DeletableRowList = (props, context) => {
  const values = dotAccess.get(props.resource, props.name);
  return (
    <div className="DeletableRowList">
      {values.length ? values.map((v, i) =>
        <DeletableRow key={i}
                      value={v[props.labelProperty]}
                      resource={v}
                      parentResource={props.resource}
                      handleRemove={props.handleRemove}
                      handleResend={props.handleResend}
                      updateResults={props.updateResults}
        			  showDeleteButton={props.showDeleteButton}
        />) :
        <div className="no-results">{getLabel(context.locale, props.emptyMessage)}</div>}
    </div>
  );
};

DeletableRowList.contextTypes = {
  locale: PropTypes.string,
};

export default DeletableRowList;



// WEBPACK FOOTER //
// ./src/main/components/container/DeletableRow.js